<template>
  <v-row>
    <v-col cols="12">
      <gg-card-title class="pb-0 pt-0">
        Service Status
      </gg-card-title>
    </v-col>
    <v-col cols="12" v-for="item in itemsSorted" :key="item.id">
        <down-time-item :item="item" />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import DownTimeItem from '@/components/DownTime/DownTimeItem'

export default {
  name: 'DowntimeView',
  components: {
    DownTimeItem
  },
  computed: {
    ...mapGetters({
      items: 'downtime/events'
    }),
    itemsSorted () {
      return this.items.slice().sort((a, b) => b.id - a.id)
    }
  }
}
</script>

<style scoped>

</style>
